<template>
  <div class="house-area">
    <el-dialog title="批量设置区域" :visible.sync="visible" width="1000px" @close="onClose">
      <div class="bt-container">
        <div class="bt-container-header">
          <el-select v-model="parent_id" size="mini" filterable clearable placeholder="选择区域">
            <el-option v-for="(item,index) in house_tree_list" :key="index" :label="item.ancestor_name" :value="item.house_id"></el-option>
          </el-select>
        </div>
        <div class="bt-container-body">
          <el-table
            :data="house_list2"
            border
            style="width: 100%" height="60vh">
            <el-table-column
              fixed
              prop="ancestor_name"
              label="房产名称">
            </el-table-column>
            <el-table-column
              prop="house.charging"
              label="计费面积"
              width="120">
            </el-table-column>
            <el-table-column
              prop="type"
              label="房产类型"
              width="100">
              <template slot-scope="scope">
                <span>{{house_type[scope.row.type]}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="house.room_status_name"
              label="房态"
              width="100">
            </el-table-column>
            <el-table-column
              prop="customer.name"
              label="业主"
              width="150">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <template #footer>
        <div style="text-align: right">
          <el-button size="mini" @click="visible=false">取 消</el-button>
          <el-button size="mini" type="primary" @click="submit">修 改</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Http from "../../../common/Http";

export default {
  name: "HouseArea",
  data() {
    return {
      visible: false,
      house_list: [],
      house_list2:[],
      house_tree_list: [],
      _callback: null,
      house_type:{
        0:"空",
        1:"住宅",
        2:"车位",
        3:"储藏室",
        4:"商铺",
      },
      project_id:"",
      parent_id:"",
      parent_data:{}
    }
  },
  methods: {
    show({project_id,list},callback) {
      this.visible = true;
      this.project_id = project_id;
      this.house_list = JSON.parse(JSON.stringify(list));
      this.house_list2 = JSON.parse(JSON.stringify(list));
      this._callback = callback;
      this.getHouseTree();
    },
    getHouseTree() {
      const that = this;
      Http.get("HouseTree/getHouseTree",{project_id:that.project_id,is_tree:0},ret=>{
        if(ret.code){
          that.house_tree_list = ret.data;
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    onClose() {
      this.visible = false;
      this.project_id = "";
      this.house_list = [];
      this.house_list2 = [];
      this.house_tree_list=[];
      this.parent_id = "";
      this.parent_data = {};
      this._callback = undefined;
    },
    submit() {
      const that = this;
      if(!(that.parent_data&&that.parent_data.house_id)){
        that.$message.error("请选择区域");
        return false;
      }
      Http.post("HouseTree/batchUpdateHouse",{
        parent_data:that.parent_data,
        house_list:that.house_list2,
      },ret=>{
        if(ret.code){
          that.visible=false;
          typeof that._callback === "function" && that._callback();
        }else {
          that.$message.error(ret.msg);
        }
      })
    },
    updateArea() {
      const that = this;
      that.house_list2=[];
      if(that.parent_data&&that.parent_data.house_id){
        that.house_list.forEach(item => {
          let t=JSON.parse(JSON.stringify(item));
          t.parent_id=that.parent_data.house_id;
          t.project_house_id=that.parent_data.project_house_id;
          t.area_id=that.parent_data.house_id;
          t.ancestor_ids=that.parent_data.ancestor_ids+","+t.house_id;
          t.ancestor_name=that.parent_data.ancestor_name+"->"+t.house_name;
          t.level=that.parent_data.level+1;
          t.deepest_node=1;
          that.house_list2.push(t);
        });
      }else {
        that.house_list.forEach(item => {
          let t=JSON.parse(JSON.stringify(item));
          that.house_list2.push(t);
        });
      }

    },
  },
  watch:{
    parent_id(val){
      const that = this;
      that.parent_data = that.house_tree_list.find(item => item.house_id === val);
      that.updateArea();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/house/components/HouseArea.vue